<template>
  <div class="form-textarea">
    <label v-if="label" :for="id">{{ label }}</label>
    <div class="inner-wrap position-relative">
      <div class="fake-textarea form-control form-control-lg overflow-hidden" style="" v-html="htmlValue">&nbsp;
      </div>
      <textarea ref="textarea"
                :id="id"
                class="form-control form-control-lg"
                :placeholder='placeholderText'
                :required="required"
                :maxlength="maxlength"
                :value="value"
                @invalid.prevent="invalid=true"
                @input="$emit('input', $event.target.value)"
      ></textarea>
    </div>
    <div class="input-info">
			<span class="invalid-note" :style="required && characterCount <=0?'visibility: visible !important':''">
				{{ invalidNote }}
			</span>
      <span v-if="showCharacterCount" class="character-count float-right text-secondary">
				{{ characterCount }} / {{ maxlength }} {{ $t('Zeichen') }}
			</span>
    </div>

  </div>
</template>

<script>
import {v1} from 'uuid';
// import emitHeight from '../mixins/emit-height';

export default {
  name: "FormTextarea",
  // mixins: [emitHeight],
  props: {
    value: {type: String, default: ''},
    label: {type: String, default: ''},
    placeholder: {type: String, default: ''},
    required: {type: Boolean, default: false},
    invalidNote: {type: String, default: 'invalid input'},
    maxlength: {type: Number, default: () => Number.MAX_SAFE_INTEGER}
  },
  data() {
    return {
      id: v1()
    }
  },
  computed: {
    htmlValue() {
      return this.value
          .replace(/</gi, "&lt;")
          .replace(/>/gi, "&gt;")
          .replace(/&/gi, "&amp;")
          .replace(/\n/gi, "<br>&nbsp;")
    },
    placeholderText() {
      let parts = [this.placeholder]
      if (this.required) {
        parts.push('*')
      }
      return parts.join(' ')
    },
    characterCount() {
      return this.value.length
    },
    showCharacterCount() {
      return this.maxlength < Number.MAX_SAFE_INTEGER
    }
  },
}

</script>

